module.exports = __webpack_public_path__ + "static/media/6_presentation.ed9cb592.jpg";